import {Component, Input, OnInit, OnChanges, Output, EventEmitter, ViewChild, ElementRef, NgZone } from "@angular/core";
import { SkillTag } from "src/app/modules/algebrakit/types/algebrakit.types";
import {I18N, TagMap } from "../../../modules/algebrakit/types/tags.types";

// const TAGS: TagCollection = new TagCollection(TAGS_JSON);
// const TAGIDMAP:{[id:string]:Tag} = {};

// function getAllTagsFromCollection(col:TagCollection) {
//     if(col.tags) {
//         col.tags.forEach(_tag => TAGIDMAP[_tag.id]=_tag);
//     }
//     if(col.collections) col.collections.forEach(_col => getAllTagsFromCollection(_col));
// }
// getAllTagsFromCollection(TAGS);

@Component({
    selector: "app-skill-tag-viewer",
    templateUrl: "./skill-tag-viewer.component.html",
    styleUrls: ["./skill-tag-viewer.component.less"],
    standalone: false
})
export class SkillTagViewerComponent  {
    @Input() tag: SkillTag;
    @Input() tagMap: TagMap;
    expanded = false;
    
    getTagDescription() {
        let tag = this.tagMap[this.tag.id];
        let lang = Object.keys(tag.descr)[0];
        if(tag) return tag.descr[lang];
    }

    getDescription(descr:I18N):string {
        if(!descr) return '';
        let lang = Object.keys(descr)[0];
        return descr[lang];
    }
    
    getErrors() {
        if(!this.tag.errors) return;

        let tagSpec = this.tagMap[this.tag.id];
        return this.tag.errors
            .map(_errId => tagSpec.errors.find(_err => _err.id == _errId))
            .filter(_err => !!_err);

    }

    getTagSource() {
        switch(this.tag.source) {
            case 'ERROR_FEEDBACK': return 'from error feedback';
            case 'HINT': return 'from hint';
            case 'FINISHED_STEP': return 'from completed step';
            case 'NEXT_STEP': return 'from next step';
        }
    }
}
